import {queryQuizServerGqlApi} from "../graphql/queryQuizServerGqlApi";
import {IDataClientService} from "../../../platform/services/data/DataClientService";
import {IAuthService} from "../../../platform/services/auth/AuthService";

import {listQuizQuestions as listQuizQuestionsGQL} from '../graphql/queries';


export const listQuizQuestions = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string,
    quizId: string
): Promise<any> => {
    const listQuizQuestionsResponse = await queryQuizServerGqlApi(
        dataClientService,
        authService,
        listQuizQuestionsGQL,
        {
            wsId: wsId,
            quizId: {
                eq: quizId,
            }
        },
    );

    return listQuizQuestionsResponse;
}
